<template>
  <div class="drop-list" :class="{ expanded }">
    <div class="head" :class="{ bordered }">
      <div class="text" @click="toggleExpand">
        <slot name="header"/>
      </div>
      <button @click="toggleExpand" class="h-btn h-empty-btn">
        <svg v-if="expanded" width="6.66" height="3.96" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 0.366666V2.11667H0V0.366666H5Z" fill="#4C5056"/>
        </svg>
        <svg v-else width="10.56" height="11.88" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5.11667H4.88333V8.25H3.13333V5.11667H0V3.36667H3.13333V0.25H4.88333V3.36667H8V5.11667Z" fill="$mainGreen"/>
        </svg>
      </button>
    </div>
    <div v-if="expanded" class="body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    bordered: {
      type: Boolean,
      default: false,
    },
    opened: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      expanded: this.opened,
    }
  },

  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    }
  }

}
</script>

<style lang="scss" scoped>

.drop-list {

  .head {
    height: 60px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .text {
      font-weight: bold;
      font-size: 16px;
      color: $mainGreen;
      cursor: pointer;
      user-select: none;
    }

    .h-btn {
      width: 26px;
      height: 26px;
    }

    &.bordered {
      border-bottom: 1px solid #E4E5E6;
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &.expanded {
    .head {
      .text {
        color: #4C5056;
      }
    }
  }
}

</style>